export { default } from './LeftPanelPayrollEoy';
